import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { typologiesData } from '../../data/mock';
import { Link } from 'react-router-dom';

const Typologies = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#FAFAFA]" data-testid="typologies-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <p className="text-[#666] text-sm tracking-[0.2em] uppercase mb-4">
            Nos Résidences
          </p>
          <h2 
            className="text-4xl lg:text-5xl text-[#1a1a1a] mb-6 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {typologiesData.title}
          </h2>
          <p className="text-[#666] text-lg leading-relaxed">
            {typologiesData.subtitle}
          </p>
        </div>

        {/* Typologies Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          {typologiesData.types.map((type, index) => (
            <div
              key={type.id}
              className="group bg-white hover-lift card-shadow"
              data-testid={`typology-${type.id}`}
            >
              {/* Image */}
              <div className="relative h-72 overflow-hidden">
                <img
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover img-zoom"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>

              {/* Content */}
              <div className="p-8">
                <p className="text-[#2D5A27] text-sm tracking-wide mb-2">{type.subtitle}</p>
                <h3 
                  className="text-2xl text-[#1a1a1a] mb-4"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {type.title}
                </h3>
                <p className="text-[#666] text-sm leading-relaxed mb-6">
                  {type.description}
                </p>

                {/* Features */}
                <div className="grid grid-cols-2 gap-2 mb-6">
                  {type.features.map((feature) => (
                    <div key={feature} className="flex items-center gap-2">
                      <Check className="w-4 h-4 text-[#2D5A27]" />
                      <span className="text-[#666] text-sm">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <Link to="/contact">
                  <button className="flex items-center gap-2 text-[#1a1a1a] text-sm font-medium group/btn">
                    En savoir plus
                    <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Typologies;
